"use client";

import NextTopLoader from "nextjs-toploader";

/**
 * Global route-transition progress bar (link clicks, router.push, back/forward).
 * Placed once at the app root; uses theme primary tokens and skips hash-only jumps.
 */
export function NavigationProgress() {
  return (
    <NextTopLoader
      color="var(--color-primary-500)"
      initialPosition={0.1}
      crawlSpeed={200}
      height={3}
      crawl
      showSpinner={false}
      easing="ease"
      speed={200}
      shadow="0 0 0.625rem var(--color-primary-400), 0 0 0.3125rem var(--color-primary-500)"
      zIndex={9999}
      showAtBottom={false}
      showForHashAnchor={false}
    />
  );
}
